import { Flex, Heading, Text } from "@chakra-ui/react";
import type { FlexProps } from "@chakra-ui/react";
import type { ReactNode } from "react";

import theme from "theme";

interface HeroProps extends FlexProps {
  children?: ReactNode;
}

export default function Hero({ children, ...rest }: HeroProps) {
  return (
    <Flex flexDirection="column" alignItems="center" {...rest}>
      <Heading
        marginTop={theme.spacing.xxxl}
        fontSize={[
          theme.fontSizes.headingLg,
          theme.fontSizes.headingLg2,
          theme.fontSizes.headingLg3,
        ]}
        data-cy="title-heading"
      >
        The{" "}
        <Text display="inline" color="brand.500">
          Rock
        </Text>{" "}
        Program
      </Heading>
      {children ? (
        <Text fontSize={theme.fontSizes.headingXs} data-cy="subtitle-heading">
          {children}
        </Text>
      ) : null}
    </Flex>
  );
}
